import {useEffect, useState} from 'react';
import firebaseInit from 'firebase-init';
import appConfig from 'config/app.config';
import {getBrowserLanguage} from 'helpers/language-helper';
import {getGameUrl} from 'helpers/game-helper';
import {getOrientation, getAspectRatio, checkIfInStandaloneMode} from 'helpers/device-helper';
import AdminLoginController from './admin/admin-login/admin-login-controller';
import PlayerController from './users/player-controller';
import ImageLoader from './ui/image-loader/image-loader';
import './app.scss';

const App = () => {
	/* Language id */
	const browserLanguageId = getBrowserLanguage();

	/* Get game url */
	const gameUrl = getGameUrl(window.location.pathname);
	
	/* Device info */
	const [deviceInfo, setDeviceInfo] = useState(() => {
		return {
			isInStandaloneMode: checkIfInStandaloneMode(),
			isUsingTouch: false,
			orientation: getOrientation(),
			aspectRatio: getAspectRatio()
		};
	});

	/**
	 * User resized window, update orientation and aspect ratio
	 */
	const handleWindowResize = () => {
		let newDeviceInfo = JSON.parse(JSON.stringify(deviceInfo));
		newDeviceInfo.orientation = getOrientation();
		newDeviceInfo.aspectRatio = getAspectRatio();
		setDeviceInfo(newDeviceInfo);
	};

	/**
	 * Scroll to top
	 */
	const scrollToTop = () => {
		const AppDiv = document.getElementById('App');
		if (AppDiv) AppDiv.scrollTop = 0;
	};
	
	/**
	 * Component mounted / will unmount
	 */
	useEffect(() => {
		/* Component mounted */

		/* Initialize firebase */
		firebaseInit();

		/* Add event listener for window size */
		if (document.addEventListener) window.addEventListener('resize', handleWindowResize, false);

		/* Component will ummount */
		return () => {
			if (document.removeEventListener) window.removeEventListener('resize', handleWindowResize, false);
		};
	});

	if (gameUrl === appConfig.adminUri) {
		return (
			<div id="App" className={'App ' + deviceInfo.orientation}>
				<AdminLoginController languageId={browserLanguageId} scrollToTop={scrollToTop} />
			</div>
		);
	}

	return (
		<div id="App" className={'App ' + deviceInfo.orientation}>
			<PlayerController languageId={browserLanguageId} deviceInfo={deviceInfo} scrollToTop={scrollToTop} />
			<ImageLoader type="basic" />
		</div>
	);
};

export default App;
